/**
 * Holds the register plugin types (DataProviders, matchers)
 * @module
 */
var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var enums = require('../constants/enums');
var Logger = require('../utils/logger');

module.exports = {
  initialize: function() {
    this.__state = _.mapValues(enums.PluginTypes, function() {
      return {};
    });

    this.on(actionTypes.REGISTER_PLUGIN, this.__registerPlugin);
  },

  /**
   * Registers plugin with data from payload
   * @private
   * @param {Object} payload
   * @param {string} payload.type
   * @param {string} payload.name
   * @param {Object} [payload.plugin]
   */
  __registerPlugin: function(payload:any) {
    var type = payload.type;
    var name = payload.name;
    var plugin = payload.plugin;
    if (!type || !name) {
      throw new Error('Missing information needed to register plugins: ' +
        type + ':' + name);
    } else if (!this.__state[type]) {
      throw new Error('Invalid plugin type specified: ' + type);
    } else {
      this.__state[type][name] = plugin;
      Logger.debug('Plugin Store: Registering Plugin :', payload);
    }
  },

  /**
   * Returns collection of plugins of specified type or all plugins, if no type specified
   * @param {string} [type]
   * @return {Object} plugin
   */
  getAllPlugins: function(type?:string): any {
    if (!type) {
      return this.__state;
    } else if (this.__state[type]) {
      return this.__state[type];
    } else {
      throw new Error('Invalid plugin type: ' + type);
    }
  },

  /**
   * Returns plugin object of the specified type and name
   * @param {string} type
   * @param {string} [name]
   * @return {Object} plugin
   */
  getPlugin: function(type:string, name?:string): any {
    if (!name || !type) {
      throw new Error('Missing plugin parameters');
    }
    var plugins = this.getAllPlugins(type);
    return plugins[name] || null;
  },
};
